const $body = $('html, body');
const $header = $('header');

// lang
const $langTrigger		= $('.lang-list .active a');
const $langList		= $('.lang-list');

// search
const $searchTrigger 	= $('#searchTrigger');
const $searchErrorTrigger 	= $('.search-submit');
const $searchForm			= $('#custom-search-api-form');

// nav-menu
const $navMenuTrigger = $('#burgerMenu');
const $navMenu				=	$('.nav-menu');

const headerHeight    = $header.hasClass('resized') ? 65 : 100;
var prevScrollTop     = 0;

const OPENED_CLASS 		= 'opened';
const HIDDEN_CLASS 		= 'hidden';

export function langToggle() {
  $langTrigger.on('click', (e) => {
    e.preventDefault();
    $langList.toggleClass(OPENED_CLASS);
  });
}

export function searchToggle() {
  $searchTrigger.on('click', function(e) {
    e.preventDefault();
    $langList.removeClass(OPENED_CLASS);
    $(this).toggleClass(OPENED_CLASS);
    $searchForm.toggleClass(OPENED_CLASS);
    $searchForm.find('#edit-index').focus();
  });

  if ($searchErrorTrigger.length) {
    $searchErrorTrigger.on('click', function(e) {
      e.preventDefault();
      $(this).parent().find('form').submit();
    });
  }
}

export function navToggle() {
  $navMenuTrigger.on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass(OPENED_CLASS);
    $navMenu.toggleClass(OPENED_CLASS);
    $body.toggleClass('no-scroll');
    if ($(this).hasClass(OPENED_CLASS)) {
      $.fn.fullpage.setMouseWheelScrolling(false);
    } else {
      $.fn.fullpage.setMouseWheelScrolling(true);
    }
  });
}

export function hideHeaderOnScroll(curScrollTop) {
  if (curScrollTop > prevScrollTop) {
    $header.addClass(HIDDEN_CLASS);
  } else if (curScrollTop === 0) {
    $header.removeClass(HIDDEN_CLASS);
  }
  // } else {
  //   $header.removeClass(HIDDEN_CLASS);
  // }
  prevScrollTop = curScrollTop;
}

export function showHeaderOnHover(state) {
  if (state === true) {
    $header.mouseenter(() => {
      $header.removeClass(HIDDEN_CLASS);
      $header.mouseleave(() => {
        $header.addClass(HIDDEN_CLASS);
      });
    });
  } else {
    $header.unbind();
  }
}



// WEBPACK FOOTER //
// ./js/header.js